import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Flex, Form, Input, message, Select, Spin, Switch} from "antd";
import {LocalName} from "../../../../../utils/LocalName";
import classes from "../../Courses/CreateCourse/CreateCourse.module.css";
import BlockLoading from "../../../../../components/LoadingComponents/BlockLoading";
import FormItem from "antd/es/form/FormItem";
import IntlMessage, {IntlMessageText} from "../../../../../components/IntlMessage/IntlMessage";
import GreyButton from "../../../../../components/UI/Buttons/GreyButton";
import {clrs} from "../../../../../constants/colors";
import UserService from "../../../../../services/UserService";
import GroupService from "../../../../../services/GroupService";
import debounce from "lodash/debounce";
import {getAllJournals} from "../../../../../store/slices/JournalSlice";

const CreationGroups = () => {
    const dispatch = useDispatch();
    const {currentPage, pageSize} = useSelector(state => state.journalsListTableController);
    const categoriesListFromRedux = useSelector(state => state.categoriesList);

    const [categories, setCategories] = useState([]);
    const [categoriesAll, setCategoriesAll] = useState([]);
    const [teachers, setTeachers] = useState([]);
    const [students, setStudents] = useState([]);
    const [courses, setCourses] = useState([]);
    const [isLoadingCreate, setIsLoadingCreate] = useState(false);
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [isLoadingTeachers, setIsLoadingTeachers] = useState(false);
    const [isLoadingStudents, setIsLoadingStudents] = useState(false);
    const [isLoadingCategories, setIsLoadingCategories] = useState(false);
    const [isLoadingCourses, setIsLoadingCourses] = useState(false);
    const [isLoadingNumber, setIsLoadingNumber] = useState(false);
    const [isGeneralEng, setIsGeneralEng] = useState(false);
    const [isFoundEng, setIsFoundEng] = useState(false);
    const [isFoundReadKaz, setIsFoundReadKaz] = useState(false);

    const [form] = Form.useForm();
    const category = Form.useWatch('category', form);
    const course = Form.useWatch('course', form);
    const nameKz = Form.useWatch('nameKz', form);
    const nameRu = Form.useWatch('nameRu', form);
    const nameEng = Form.useWatch('nameEng', form);
    const number = Form.useWatch('number', form);
    const teacher = Form.useWatch('teacher', form);
    const linkToWhatsAppGroup = Form.useWatch('linkToWhatsAppGroup', form);
    const foundEngGroup = Form.useWatch('foundEngGroup', form);
    const foundReadGroup = Form.useWatch('foundReadGroup', form);
    // const teacherContractNumber = Form.useWatch('teacherContractNumber', form);
    // const teacherContractDate = Form.useWatch('teacherContractDate', form);
    const selectedStudents = Form.useWatch('students', form);

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (categoriesListFromRedux.categories.length > 0) {
            setCategories(categoriesListFromRedux.categories.map((category) => {
                return {value: category.id, label: LocalName.getName(category)};
            }));
            setCategoriesAll(categoriesListFromRedux.categories);
        }
    }, [categoriesListFromRedux.categories]);

    useEffect(() => {
        if (category) {
            form.setFieldValue("course", null)
            form.setFieldValue("nameKz", null);
            form.setFieldValue("nameRu", null);
            form.setFieldValue("nameEng", null);
            form.setFieldValue("number", null);
            let selectedCategory = categoriesAll.find((c) => c.id === category);
            if (!!selectedCategory) {
                setCourses(selectedCategory.courses.map((course) => {
                    return {value: course.id, label: LocalName.getName(course)};
                }));
                setIsGeneralEng(selectedCategory.nameEng === 'General English');
            }
        }
    }, [category]);

    useEffect(() => {
        if (course) {
            form.setFieldValue("nameKz", null);
            form.setFieldValue("nameRu", null);
            form.setFieldValue("nameEng", null);
            form.setFieldValue("number", null);
            let selectedCategory = categoriesAll.find((c) => c.id === category);
            if (selectedCategory && selectedCategory.nameEng !== 'General English') {
                let selectedCourse = selectedCategory.courses.find((c) => c.id === course);

                if (selectedCategory.nameEng === 'Foundation' && selectedCourse && selectedCourse.nameEng === 'General English') {
                    setIsFoundEng(true)
                }
                if (selectedCategory.nameEng === 'Foundation' && selectedCourse && selectedCourse.nameEng === 'Reading literacy') {
                    setIsFoundReadKaz(true)
                }

                const nameKz = LocalName.getNameKz(selectedCourse);
                const nameRu = LocalName.getNameRu(selectedCourse);
                const nameEng = LocalName.getNameEng(selectedCourse);

                form.setFieldsValue({
                    nameKz,
                    nameRu,
                    nameEng
                });

                // Важно: дождаться установки значений, затем вызвать номер
                setTimeout(() => {
                    getLastNumberForGroup(); // теперь nameEng точно установлен
                }, 0);

            }
        }
    }, [course]);

    const getLastNumberForGroup = async () => {
        const nameEngValue = form.getFieldValue("nameEng"); // получаем актуальное значение
        if (!nameEngValue) return;

        setIsLoadingNumber(true);
        try {
            const r = await GroupService.getNextGroupNumber(nameEngValue, course);
            form.setFieldValue("number", r.data);
        } catch (error) {
            message.error(<IntlMessage id={'error'}/>, 5);
        } finally {
            setIsLoadingNumber(false);
        }
    }

    const fetchData = async () => {
        setIsLoadingData(true);
        try {
            const [teachersResponse, studentsResponse] = await Promise.allSettled([
                UserService.getTeachers(1, 100),
                UserService.getStudents(1, 100),
            ]);

            if (teachersResponse.status === 'fulfilled') {
                setTeachers(teachersResponse.value.data.map(teacher => {
                    return {
                        value: teacher.id,
                        label: teacher.fullName
                    }
                }));
            } else {
                message.error(<IntlMessage id="teachersFetchError"/>, 5);
            }

            if (studentsResponse.status === 'fulfilled') {
                setStudents(studentsResponse.value.data.map(student => {
                    return {
                        value: student.id,
                        label: (student.fullName)
                    }
                }));
            } else {
                message.error(<IntlMessage id="studentsFetchError"/>, 5);
            }
        } catch (error) {
            message.error(<IntlMessage id="error"/>, 5);
        } finally {
            setIsLoadingData(false);
        }
    };

    function handleCreate() {
        form.validateFields()
            .then(async () => {
                message.loading(<IntlMessage id={'loading'}/>, 0);
                setIsLoadingCreate(true);
                await GroupService.saveGroup(nameKz, nameRu, nameEng, number, category, course, linkToWhatsAppGroup, teacher, selectedStudents, foundEngGroup, foundReadGroup)
                    .then(() => {
                        message.destroy();
                        message.success(<IntlMessage id={'creation'}/>, 5);
                        form.resetFields();
                    })
                    .catch(() => {
                        message.destroy();
                        message.error(<IntlMessage id={'error'}/>, 5);
                        setIsLoadingCreate(false);
                    })
                    .finally(() => {
                        setIsLoadingCreate(false);
                    })
            })
            .catch(() => {
                console.log("Validation error!")
            })
            .finally(() => {
                setIsLoadingCreate(false);
                dispatch(getAllJournals({
                    page: currentPage,
                    limit: pageSize
                }));
            })
    }

    const groupOptions = [
        {
            value: "Pre-Intermediate",
            label: "Pre-Intermediate",
        },
        {
            value: "Intermediate",
            label: "Intermediate",
        }
    ]

    const foundGroupOptions = [
        {
            value: "0",
            label: "Elementary",
        },
        {
            value: "1",
            label: "Pre-Intermediate",
        },
        {
            value: "2",
            label: "Intermediate",
        }
        // {
        //     value: "3",
        //     label: "Academic English",
        // },
        // {
        //     value: "4",
        //     label: "ICT"
        // }
    ]

    const fetchStudentSearch = debounce(async (searchText) => {
        setIsLoadingStudents(true);
        try {
            const response = await UserService.getStudentsSearchable(1, 100, searchText); // предполагаем, что 3й параметр — строка поиска
            const options = response.data.map((student) => ({
                value: student.id,
                label: student.fullName,
            }));
            setStudents(options);
        } catch (e) {
            message.error(<IntlMessage id="studentsFetchError"/>);
        } finally {
            setIsLoadingStudents(false);
        }
    }, 500); // 500ms задержка

    return (
        <Form form={form} className={classes.form}>
            <BlockLoading isLoading={isLoadingCreate}/>
            <FormItem rules={[{required: true, message: <IntlMessage id={'requiredField'}/>}]}
                      className={classes.formInputBlock} name="category"
                      label={<IntlMessage id={'categoryCourse'}/>} labelCol={{span: 24}}
            >
                <Select
                    options={categories}
                    placeholder={IntlMessageText.getText({id: "categoryCourse"})}/>
            </FormItem>
            <FormItem rules={[{required: true, message: <IntlMessage id={'requiredField'}/>}]}
                      className={classes.formInputBlock} name="course"
                      label={<IntlMessage id={'course'}/>} labelCol={{span: 24}}
            >
                <Select
                    options={courses}
                    placeholder={IntlMessageText.getText({id: "course"})}
                />
            </FormItem>
            {isGeneralEng && (
                <Form.Item
                    name="nameEng"
                    label={<IntlMessage id="group"/>}
                    labelCol={{span: 24}}
                    rules={[{required: isGeneralEng, message: <IntlMessage id="requiredField"/>}]}
                    className={classes.formInputBlock}
                >
                    <Select
                        style={{width: '100%'}}
                        options={groupOptions}
                        placeholder={<IntlMessage id="group"/>}
                        onChange={(value) => {
                            form.setFieldsValue({
                                nameKz: value,
                                nameRu: value,
                                nameEng: value
                            });
                            setTimeout(() => {
                                getLastNumberForGroup();
                            }, 0);
                        }}
                    />
                </Form.Item>
            )}
            {isFoundEng && (
                <Form.Item
                    name="foundEngGroup"
                    label={<IntlMessage id="group"/>}
                    labelCol={{span: 24}}
                    rules={[{required: isFoundEng, message: <IntlMessage id="requiredField"/>}]}
                    className={classes.formInputBlock}
                >
                    <Select
                        style={{width: '100%'}}
                        options={foundGroupOptions}
                        placeholder={<IntlMessage id="group"/>}
                    />
                </Form.Item>
            )}
            {isFoundReadKaz && (
                <Form.Item
                    name="foundReadGroup"
                    label={<IntlMessage id="tg.kazakhGroup"/>}
                    labelCol={{span: 24}}
                    className={classes.formInputBlock}
                >
                    <Switch/>
                </Form.Item>
            )}
            <FormItem rules={[{
                required: true,
                message: <IntlMessage id={'requiredField'}/>,
            },
            ]} label={<IntlMessage id={'nameKz'}/>} labelCol={{span: 24}} className={classes.formInputBlock}
                      name="nameKz">
                <Input rootClassName={classes.formInput} placeholder={IntlMessageText.getText({id: "nameKz"})}/>
            </FormItem>
            <FormItem rules={[{
                required: true,
                message: <IntlMessage id={'requiredField'}/>,
            },
            ]} label={<IntlMessage id={'nameRu'}/>} labelCol={{span: 24}} className={classes.formInputBlock}
                      name="nameRu">
                <Input rootClassName={classes.formInput} placeholder={IntlMessageText.getText({id: "nameRu"})}/>
            </FormItem>
            <FormItem rules={[{
                required: true,
                message: <IntlMessage id={'requiredField'}/>,
            },
            ]} label={<IntlMessage id={'nameEng'}/>} labelCol={{span: 24}} className={classes.formInputBlock}
                      name="nameEng">
                <Input rootClassName={classes.formInput} placeholder={IntlMessageText.getText({id: "nameEng"})}/>
            </FormItem>
            <FormItem rules={[{
                required: true,
                message: <IntlMessage id={'requiredField'}/>,
            },
            ]} label={<IntlMessage id={'number'}/>} labelCol={{span: 24}} className={classes.formInputBlock}
                      name="number">
                <Input rootClassName={classes.formInput} disabled
                       placeholder={IntlMessageText.getText({id: "number"})}/>
            </FormItem>
            {/*<FormItem rules={[{*/}
            {/*    required: false,*/}
            {/*    message: <IntlMessage id={'requiredField'}/>,*/}
            {/*},*/}
            {/*]} label={<IntlMessage id={'linkToWhatsAppGroup'}/>} labelCol={{span: 24}} className={classes.formInputBlock}*/}
            {/*          name="linkToWhatsAppGroup">*/}
            {/*    <Input rootClassName={classes.formInput} placeholder={IntlMessageText.getText({id: "linkToWhatsAppGroup"})}/>*/}
            {/*</FormItem>*/}
            <FormItem rules={[{required: true, message: <IntlMessage id={'requiredField'}/>}]}
                      className={classes.formInputBlock} name={"teacher"}
                      label={<IntlMessage id={'ordersPage.teacher'}/>} labelCol={{span: 24}}
            >
                <Select options={teachers}
                        placeholder={<IntlMessage id={'ordersPage.teacher'}/>}
                />
            </FormItem>
            {/*<FormItem rules={[{*/}
            {/*    required: true,*/}
            {/*    message: <IntlMessage id={'requiredField'}/>,*/}
            {/*},*/}
            {/*]} label={<IntlMessage id={'teacherContractNumber'}/>} labelCol={{span: 24}} className={classes.formInputBlock}*/}
            {/*          name="teacherContractNumber">*/}
            {/*    <Input placeholder={IntlMessageText.getText({id: "teacherContractNumber"})}/>*/}
            {/*</FormItem>*/}
            {/*<FormItem rules={[{*/}
            {/*    required: true,*/}
            {/*    message: <IntlMessage id={'requiredField'}/>,*/}
            {/*},*/}
            {/*]} label={<IntlMessage id={'teacherContractDate'}/>} labelCol={{span: 24}} className={classes.formInputBlock}*/}
            {/*          name="teacherContractDate">*/}
            {/*    <Input type={'date'} className={classes.formInput} style={{maxWidth: 200}}/>*/}
            {/*</FormItem>*/}
            <FormItem
                rules={[{required: false, message: <IntlMessage id={'requiredField'}/>}]}
                className={classes.formInputBlock}
                name="students"
                label={<IntlMessage id="ordersPage.students"/>}
                labelCol={{span: 24}}
            >
                <Select
                    mode="multiple"
                    allowClear
                    showSearch
                    filterOption={false}
                    onSearch={fetchStudentSearch}
                    loading={isLoadingStudents}
                    notFoundContent={isLoadingStudents ? <Spin size="small"/> : null}
                    placeholder={<IntlMessage id="ordersPage.students"/>}
                    options={students}
                />
            </FormItem>

            <FormItem className={classes.formInputBlock}>
                <Flex align={"flex-start"} justify={"flex-start"} gap={20} style={{width: "100%"}}>
                    <GreyButton onClick={handleCreate} backgroundColor={clrs.blackerBlue}
                                fontColor={clrs.white}><IntlMessage
                        id={'create'}/></GreyButton>
                </Flex>
            </FormItem>
        </Form>
    );
};

export default CreationGroups;